
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


@Component({})
class AccountProfilePicture extends Vue {
  @Prop({ default: '' }) imageSrcUrl?: string
  @Prop({ default: 120 }) imageSize?: number

  profileImageScaleRatio: number = 0.8

  defaultProfilePictureBackgroundImageUrl: string = projectVariables.digitalCurrencyAccountDefaultBackgroundImageForColorfulEffectImageIconUrl

  get profileImageSize (): number {
    return this.imageSize! * this.profileImageScaleRatio
  }

  get getProfileImageSizeMarginDifference (): number {
    return Math.floor((this.imageSize! - this.profileImageSize) / 2)
  }

  get profileImageBorderPadding (): number {
    return Math.floor(this.getProfileImageSizeMarginDifference / 2)
  }
}
export default AccountProfilePicture
